<script setup>
defineProps({
  event: {
    type: Object,
    required: true,
  },
  registrationUrl: {
    type: String,
    default: '',
  },
  zoomUrl: {
    type: String,
    default: '',
  },
  vimeoJoinUrl: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div class="event-modal__cta-sidebar">
    <ul class="event-modal__cta-sidebar-block">
      <li v-if="event.ical_download_url" class="event-modal__cta-item calendar">
        <a
          :href="event.ical_download_url"
          class="event-modal__cta-link"
          :aria-label="`Add ${event.title} to calendar`"
          download
        >
          <span>Add to Calendar</span>
        </a>
        <div class="event-modal__cta-icon calendar-add-btn" aria-hidden="true">
          <svg
            class="calendar-icon"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 100 100"
            x="0px"
            xmlns="http://www.w3.org/2000/svg"
            y="0px"
          >
            <line
              fill="none"
              vector-effect="non-scaling-stroke"
              x1="50"
              x2="50"
              y1="0"
              y2="100"
            ></line>
            <line
              fill="none"
              vector-effect="non-scaling-stroke"
              x1="0"
              x2="100"
              y1="50"
              y2="50"
            ></line>
          </svg>
        </div>
      </li>
      <li v-if="event.course_slug" class="event-modal__cta-item course">
        <RouterLink
          :to="{ name: 'course-view', params: { courseSlug: event.course_slug } }"
          class="event-modal__cta-link"
        >
          <span>View Course</span>
        </RouterLink>
        <div class="event-modal__cta-icon course-add-btn" aria-hidden="true">
          <svg data-dir="up_right" viewBox="0 0 1001.79 901.97" xmlns="http://www.w3.org/2000/svg">
            <line
              fill="none"
              stroke-linecap="round"
              vector-effect="non-scaling-stroke"
              x1="0.7"
              x2="999.79"
              y1="450.8"
              y2="450.8"
            ></line>
            <polyline
              fill="none"
              points="461.58 0.99 1000.7 450.8 461.58 900.99"
              stroke-linecap="round"
              vector-effect="non-scaling-stroke"
            ></polyline>
          </svg>
        </div>
      </li>
      <li v-if="registrationUrl" class="event-modal__cta-item registration">
        <a
          :href="registrationUrl"
          class="event-modal__cta-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Registration</span>
        </a>
        <div class="event-modal__cta-icon registration-add-btn" aria-hidden="true">
          <svg data-dir="up_right" viewBox="0 0 1001.79 901.97" xmlns="http://www.w3.org/2000/svg">
            <line
              fill="none"
              stroke-linecap="round"
              vector-effect="non-scaling-stroke"
              x1="0.7"
              x2="999.79"
              y1="450.8"
              y2="450.8"
            ></line>
            <polyline
              fill="none"
              points="461.58 0.99 1000.7 450.8 461.58 900.99"
              stroke-linecap="round"
              vector-effect="non-scaling-stroke"
            ></polyline>
          </svg>
        </div>
      </li>
      <li v-if="zoomUrl" class="event-modal__cta-item zoom">
        <a :href="zoomUrl" class="event-modal__cta-link" target="_blank" rel="noopener noreferrer">
          <span>Join Zoom</span>
        </a>
        <div class="event-modal__cta-icon zoom-add-btn" aria-hidden="true">
          <svg data-dir="up_right" viewBox="0 0 1001.79 901.97" xmlns="http://www.w3.org/2000/svg">
            <line
              fill="none"
              stroke-linecap="round"
              vector-effect="non-scaling-stroke"
              x1="0.7"
              x2="999.79"
              y1="450.8"
              y2="450.8"
            ></line>
            <polyline
              fill="none"
              points="461.58 0.99 1000.7 450.8 461.58 900.99"
              stroke-linecap="round"
              vector-effect="non-scaling-stroke"
            ></polyline>
          </svg>
        </div>
      </li>
      <li v-if="vimeoJoinUrl" class="event-modal__cta-item livestream">
        <a
          :href="vimeoJoinUrl"
          class="event-modal__cta-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Join Livestream</span>
        </a>
        <div class="event-modal__cta-icon livestream-add-btn" aria-hidden="true">
          <svg data-dir="up_right" viewBox="0 0 1001.79 901.97" xmlns="http://www.w3.org/2000/svg">
            <line
              fill="none"
              stroke-linecap="round"
              vector-effect="non-scaling-stroke"
              x1="0.7"
              x2="999.79"
              y1="450.8"
              y2="450.8"
            ></line>
            <polyline
              fill="none"
              points="461.58 0.99 1000.7 450.8 461.58 900.99"
              stroke-linecap="round"
              vector-effect="non-scaling-stroke"
            ></polyline>
          </svg>
        </div>
      </li>
    </ul>
  </div>
</template>
